import { Checkbox, CheckboxGroup, Grid, Stack, Text } from "@chakra-ui/react";
import { forwardRef } from "react";
import { FormattedMessage } from "react-intl";
import HoldersAvatar from "../../Holders/Avatar";

const HoldersSelectMultipleGrid = forwardRef(
  /**
   * @typedef {Object} Props
   * @property {import("@raiden/library/types/Holder").Holder[]} holders
   * @property {boolean} isRequired
   * @property {boolean} isInvalid
   * @property {boolean} isDisabled
   * @property {(holder: import("@raiden/library/types/Holder").Holder) => { isDisabled: boolean, reason?: string }} [validator]
   * @property {number} [maxW]
   */
  /**
   * @param {Props & import("@chakra-ui/react").CheckboxGroupProps} props
   */
  function HoldersSelectMultipleGrid(
    {
      holders,
      isRequired,
      isInvalid,
      validator,
      isDisabled,
      maxW,
      ...otherProps
    },
    ref,
  ) {
    return (
      <CheckboxGroup
        {...otherProps}
        colorScheme="brandPrimary"
        isDisabled={isDisabled}>
        {holders.length > 0 ? (
          <Grid
            gridTemplateColumns={`repeat(auto-fill, minmax(min(100px, 100%), 1fr))`}
            gridGap="0.75rem">
            {holders.map((holder, index) => {
              const enabledState = validator?.(holder);
              return (
                <Stack
                  as="label"
                  spacing=".5rem"
                  cursor={
                    enabledState?.isDisabled === true
                      ? "not-allowed"
                      : "pointer"
                  }
                  borderWidth="1px"
                  px=".5rem"
                  py="1rem"
                  key={holder.id}>
                  <Checkbox
                    ref={index === 0 ? ref : undefined}
                    value={String(holder.id)}
                    isDisabled={enabledState?.isDisabled === true || isDisabled}
                    flexDir="column-reverse"
                    textAlign="center"
                    colorScheme="brandPrimary">
                    <Stack ml="-.5rem" mb="0.25rem">
                      <HoldersAvatar holder={holder} maxW={maxW} />

                      <Text as="span">
                        {`${holder.first_name} ${holder.last_name}`}
                      </Text>
                    </Stack>
                  </Checkbox>

                  {enabledState?.isDisabled === true && enabledState?.reason && (
                    <Text
                      fontSize="1rem"
                      lineHeight="1rem"
                      fontWeight={500}
                      textAlign="center">
                      {enabledState?.reason}
                    </Text>
                  )}
                </Stack>
              );
            })}
          </Grid>
        ) : (
          <Text colorScheme="gray">
            <FormattedMessage defaultMessage="Aucun adhérent n'a été trouvé." />
          </Text>
        )}
      </CheckboxGroup>
    );
  },
);

export default HoldersSelectMultipleGrid;
